import { render, staticRenderFns } from "./GameTypeManage.vue?vue&type=template&id=47b9a60b&scoped=true&"
import script from "./GameTypeManage.vue?vue&type=script&lang=js&"
export * from "./GameTypeManage.vue?vue&type=script&lang=js&"
import style0 from "./GameTypeManage.vue?vue&type=style&index=0&id=47b9a60b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b9a60b",
  null
  
)

export default component.exports